import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomePage.vue";
import TheAboutUs from "@/components/TheAboutUs.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: TheAboutUs,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
